import { render, staticRenderFns } from "./videoInstructionPopup.vue?vue&type=template&id=154c7e71&scoped=true&"
import script from "./videoInstructionPopup.vue?vue&type=script&lang=js&"
export * from "./videoInstructionPopup.vue?vue&type=script&lang=js&"
import style0 from "./videoInstructionPopup.vue?vue&type=style&index=0&id=154c7e71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c7e71",
  null
  
)

export default component.exports